/**
 * Angular l10n
 * An Angular library to translate messages, dates and numbers
 * Copyright Roberto Simonetti
 * MIT license
 * https://github.com/robisim74/angular-l10n
 */

/**
 * Entry point for all public APIs of the package.
 */
export * from './src/angular-l10n';
